import Image from 'app/Components/Shared/Image/image';
import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import BtnWhiteBlackBorderSmallSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../../Config';
import useSaveToCalender from '../../../../../utilities/hooks/useSaveToCalender';

import iconlight from '../../images/icon-light.svg';
import success_icon from '../../images/success_icon.svg';

import { goToNextPageAsync } from '../../ServiceAppointmentAsyncthunk';

const DeliverySuccessPage = (props) => {


  function saveToCalender(){
    const calendarSettings = {
      deliverySlots: {
        deliveryStartTime: props.deliveryStartTime,
      }
    };
    useSaveToCalender(calendarSettings);
    }

  function toLobbyPage(){
    EpiContext.navigateTo(Config.lobbyUrl);
  }

  return (
      <div className='delivery-success-page page-wrapper'>
        <div className='content'>
          <Image className='info-img' src={success_icon} />
          <div className='title-wrapper'>
              <h1 className='title'>השליח יגיע ביום <span className='date' dangerouslySetInnerHTML={{ __html: props.selectedDeliveryTimeDisplay }} /></h1>
              <h2 className='title'>ל{props.fullAddress}</h2>
              <div className='sub-title'>טלפון איש קשר: {props.phoneNumber}</div>
          </div>
          {/* <div className='info-message'>בזמן ביקור השליח, חייב להיות בבית מבוגר מעל גיל 18</div> */}
        </div>

          <div className='button-wrapper'>
            <BtnWhiteBlackBorderSmallSize
                text={'הוספת תזכורת ליומן'}
                onclick={saveToCalender}
            />
            <BtnWhiteBlackBorderSmallSize
                text={'לאיזור האישי'}
                onclick={toLobbyPage}
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fullAddress: state.serviceAppointmentSchedulerBlock.delivery?.address?.fullAddress,
    selectedDeliveryTimeDisplay: state.serviceAppointmentSchedulerBlock?.delivery.selectedDeliveryTimeDisplay,
    phoneNumber: state.serviceAppointmentSchedulerBlock?.delivery?.address?.phoneNumber,
    deliveryStartTime: state.serviceAppointmentSchedulerBlock?.delivery.selectedDeliveryDate.startDate,
};
}

const mapDispatchToProps = { goToNextPageAsync};

export default connect(mapStateToProps, mapDispatchToProps)(DeliverySuccessPage);
